.support-grid {
  --support-gap: clamp(16px, 2.5vw, 40px);
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--support-gap);

  .support-card[data-motion='card']:nth-child(1) {
    --motion-delay: 0ms;
  }

  .support-card[data-motion='card']:nth-child(2) {
    --motion-delay: 80ms;
  }

  .support-card[data-motion='card']:nth-child(3) {
    --motion-delay: 160ms;
  }
}

.support-card {
  display: flex;
  flex-direction: column;
  gap: clamp(12px, 1.2vw, 18px);
  padding: clamp(28px, 2.5vw, 40px);
  background: #f6f5ee;
  color: #160004;
  text-decoration: none;
  box-sizing: border-box;
  transition: transform 320ms var(--motion-ease-luxury, ease);

  &:hover,
  &:focus-visible {
    transform: translateY(-4px);

    .support-icon {
      background-color: #160004;
      border-color: #160004;
      color: #fff;
    }

    .support-cta svg {
      transform: translateX(4px);
    }
  }

  &:focus-visible {
    outline: 1px solid #160004;
    outline-offset: 4px;
  }
}

.support-icon {
  position: relative;
  width: clamp(56px, 4.5vw, 72px);
  height: clamp(56px, 4.5vw, 72px);
  border: 1px solid rgba(22, 0, 4, 0.2);
  border-radius: 50%;
  color: #160004;
  transition:
    background-color 220ms ease,
    border-color 220ms ease,
    color 220ms ease;

  // Recolor the single-color academy SVG with currentColor
  &::after {
    content: '';
    position: absolute;
    inset: 24%;
    background-color: currentColor;
    -webkit-mask: var(--support-icon) center / contain no-repeat;
    mask: var(--support-icon) center / contain no-repeat;
  }
}

.support-title {
  margin: clamp(4px, 0.6vw, 10px) 0 0;
  color: #160004;
  font-size: clamp(24px, 1.9vw, 32px);
  font-family: Red Rose-Regular;
  font-weight: 400;
  text-wrap: balance;
  line-height: 1.12;
  letter-spacing: 0;
}

.support-desc {
  flex: 1;
  margin: 0;
  color: #5f615d;
  font-size: clamp(15px, 1.15vw, 18px);
  font-family: Red Rose-Regular;
  font-weight: normal;
  line-height: 1.55;
}

.support-cta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: var(--tap-min, 44px);
  padding-top: clamp(14px, 1.2vw, 18px);
  border-top: 1px solid rgba(22, 0, 4, 0.15);
  color: #160004;
  font-size: 14px;
  font-family: Red Rose-Regular;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
  line-height: 1;
  white-space: nowrap;

  svg {
    flex-shrink: 0;
    transition: transform 220ms ease;
  }
}

@media (max-width: 767px) {
  .support-grid {
    grid-template-columns: 1fr;
  }
}
